/*******************************************************
 * Copyright (C) 2021-2031 SAS Solicity | solicity.company@gmail.com
 *******************************************************/

import {React, createContext} from 'react';

const ConnectContext = createContext();

export {ConnectContext};